import { MembershipEditor } from "./MembershipEditor";
import { FormConfirmDialog } from "@/components/FormConfirmDialog";

import type { Control } from "react-hook-form";
import type { MembershipEditorState } from "./MembershipEditor";

export function MembershipEditorDialog({
  open,
  title,
  onClose,
  onSubmit,
  loading,
  control,
}: {
  open: boolean;
  title: string;
  onClose: () => void;
  onSubmit: () => void | PromiseLike<void>;
  loading: boolean;
  control: Control<MembershipEditorState>;
}) {
  return (
    <FormConfirmDialog
      control={control}
      title={title}
      loading={loading}
      open={open}
      onClose={onClose}
      onConfirm={onSubmit}
    >
      <MembershipEditor control={control} />
    </FormConfirmDialog>
  );
}
